var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmartphone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "smartphone",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.36,
    height: 28.88,
    viewBox: "0 0 17.36 28.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".smartphone .a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-102.115)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(109.193 23.585)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M229.2,418.133a1.6,1.6,0,1,0,1.6,1.6A1.6,1.6,0,0,0,229.2,418.133Zm0,2.095a.493.493,0,1,1,.493-.493A.493.493,0,0,1,229.2,420.228Z",
    transform: "translate(-227.598 -418.133)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(109.994 2.281)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M245.231,40.447h-2.843a.586.586,0,0,0,0,1.171h2.843a.586.586,0,0,0,0-1.171Z",
    transform: "translate(-241.802 -40.447)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(108.167 2.267)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.615,
    cy: 0.615,
    r: 0.615
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(102.115)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M117.626,0H103.964a1.851,1.851,0,0,0-1.849,1.849V27.031a1.851,1.851,0,0,0,1.849,1.849h13.662a1.851,1.851,0,0,0,1.849-1.849V1.849A1.851,1.851,0,0,0,117.626,0Zm.616,27.031a.617.617,0,0,1-.616.616H103.964a.617.617,0,0,1-.616-.616V1.849a.617.617,0,0,1,.616-.616h13.662a.617.617,0,0,1,.616.616V27.031Z",
    transform: "translate(-102.115)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104.636 4.563)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M158.565,80.892h-11.21a.555.555,0,0,0-.555.555V98.441a.555.555,0,0,0,.555.555h11.21a.555.555,0,0,0,.555-.555V81.447A.555.555,0,0,0,158.565,80.892Zm-.555,16.994h-10.1V82h10.1Z",
    transform: "translate(-146.801 -80.892)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphone);
export default __webpack_public_path__ + "static/media/smartphone.3495b271.svg";
export { ForwardRef as ReactComponent };